import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ToolLinks from '../components/ToolLinks';
import { loadToolLinksInfo } from '../actions/ToolLinksActions';
import { jsx as _jsx } from "react/jsx-runtime";
const ToolLinksContainer = props => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadToolLinksInfo(props.threadId));
  }, [dispatch, props.threadId]);
  const toolLinks = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.toolLinks);
  return /*#__PURE__*/_jsx(ToolLinks, {
    toolLinks: toolLinks
  });
};
ToolLinksContainer.propTypes = {
  threadId: PropTypes.string.isRequired
};
export default ToolLinksContainer;